import React, { useContext, useState } from "react";
import "./Hotel.css";
import Navbar from "../../components/navbar/Navbar";

import Header from "../../components/header/Header";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowAltCircleLeft,
  faArrowLeft,
  faArrowRight,
  faCircleArrowLeft,
  faCircleArrowRight,
  faCircleXmark,
  faLocationDot,
} from "@fortawesome/free-solid-svg-icons";
// import Loading from "../../components/Loading/Loading";
import Footer from "../../components/footer/Footer";
import MailList from "../../components/mailList/MailList";
import useFetch from "../../hooks/useFetch";
import { useLocation } from "react-router-dom";
import Loading from "../../components/Loading/Loading";
import { Searchcontext } from "../../context/Searchcontext";
const Hotel = () => {
  const location = useLocation();
  // eslint-disable-next-line no-restricted-globals
  const id = location.pathname.split("/")[3];
  console.log(id);
  const [on, seton] = useState(false);
  const [index, setindex] = useState(0);
  const [open, setopen] = useState(false);
  const handleopen = (i) => {
    setopen(() => true);
    setindex(i);
  };

  const { dates, option } = useContext(Searchcontext);

  const MPD = 1000 * 60 * 60 * 24;
  function dayDiff(date1, date2) {
    const timediff = Math.abs(date2.getTime() - date1.getTime());
    const diffDays = Math.ceil(timediff / MPD);
    return diffDays;
  }
  const days = dayDiff(dates[0].endDate, dates[0].startDate);

  // let data;
  // let loading;
  const { data, loading, error, reFetch } = useFetch(`/hotels/find/${id}`);
  // console.log(data);

  // console.log(data);

  const handlemove = (direction) => {
    let newindex;

    if (direction === "l") {
      newindex = index === 0 ? 5 : index - 1;
    } else {
      newindex = index === 5 ? 0 : index + 1;
    }
    setindex(() => newindex);
  };
  return (
    <div>
      <Navbar></Navbar>

      <Header type="list"></Header>

      {loading ? (
        <Loading></Loading>
      ) : (
        <div className="hotelcon">
          {open ? (
            <div className="slider">
              <div className="close" onClick={() => setopen(() => false)}>
                <FontAwesomeIcon icon={faCircleXmark} />
              </div>

              <div
                className="left"
                onClick={() => handlemove("l")}

                // onClick={() => setindex(() => (index > 0 ? index + 1 : null))}
              >
                <FontAwesomeIcon icon={faArrowLeft} />
              </div>

              <div className="sliderwraper">
                <img
                  src={data.imagegalary[index].src}
                  alt=""
                  className="sliderimg"
                />
              </div>

              <div
                className="right"
                onClick={() => handlemove("r")}
                // onClick={() =>
                //   setindex(() => (photos.length != index ? index - 1 : null))
                // }
              >
                <FontAwesomeIcon icon={faArrowRight} />
              </div>
            </div>
          ) : null}
          <div className="hotelwraper">
            <button className="booknov">Reserve or book nov</button>
            <h1 className="hoteltitle">{data.name}</h1>
            <div className="hoteladdress">
              <FontAwesomeIcon icon={faLocationDot} />
              <span>{data.city}</span>
            </div>
            <span className="hoteldistance">
              Excellent location -500 m from ccenter
            </span>
            <span className="hotelpricehighlight">
              Book a stay over ${data.chepestprice} at this property and get
              free airport texi
            </span>
            <div className="hotelimgs">
              {data.imagegalary?.map((photo, i) => (
                <div className="hotelimgwraper">
                  <img
                    onClick={() => handleopen(i)}
                    className="hotelimg"
                    src={photo.src}
                    alt=""
                  />
                </div>
              ))}
            </div>

            <div className="hoteldetail">
              <div className="hoteldetailstext">
                <p className="hoteldes">{data.desc}</p>
              </div>
              <div
                className={on ? "hoteldetailprice upside" : "hoteldetailprice"}
              >
                <h1>Perfect for a {days} night stay</h1>

                <span>
                  Located in the real heart of krakow ,this property has an
                  excellent locaion score of 9.8
                </span>

                <h2>
                  <b>${data.chepestprice * days}</b>({days} nights)
                </h2>
                <button onClick={() => seton(() => !on)}>
                  reserve or book now
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      <MailList></MailList>
      <Footer></Footer>
    </div>
  );
};

export default Hotel;
